import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { store } from "./store/store";
import { Provider } from "react-redux";
import { ListingProvider } from "./Contexts/ListingProvider";
import { MarketPlaceProvider } from "./Contexts/MarketPlace";
import { suppressResizeObserverErrors } from "./utils/errorHandling";
import mixpanel from "mixpanel-browser";

if (process.env.NODE_ENV === 'production') {
  suppressResizeObserverErrors();
}

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
  api_host: "https://api-eu.mixpanel.com",
  debug: process.env.REACT_APP_ANALYTICS_DEBUG === "true",
  track_pageview: false,
  persistence: "localStorage",
  autocapture: false,
  record_sessions_percent: 100,
});

const resizeObserverLoopErr = /ResizeObserver loop limit exceeded/;
const originalOnError = window.onerror;
window.onerror = (msg, url, lineNo, columnNo, error) => {
  if (resizeObserverLoopErr.test(msg)) {
    return true;
  }
  if (originalOnError) originalOnError(msg, url, lineNo, columnNo, error);
  return false;
};

const resizeObserverLoopCompletedErr = /ResizeObserver loop completed with undelivered notifications/;
const originalOnUnhandledRejection = window.onunhandledrejection;
window.onunhandledrejection = (e) => {
  if (resizeObserverLoopCompletedErr.test(e.reason)) {
    return;
  }
  if (originalOnUnhandledRejection) originalOnUnhandledRejection(e);
};


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ListingProvider>
      <MarketPlaceProvider>
        <Router>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </Router>
      </MarketPlaceProvider>
    </ListingProvider>
  </Provider>
);
reportWebVitals();
